import { device, siteColors } from 'src/constants/themes';
import styled from "src/utils/styled/styled";

export const VariableFlex = styled.div`
  width: 100%;
  display: flex;
  column-gap: 10px;
  @media ${device.mobileM} {
    flex-direction: column;
  }
`;
export const CheckBoxFlex = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  column-gap: 10px;
  @media ${device.tablet} {
    flex-direction: column;
    align-items: center;
    row-gap: 10px;
  }
`;

export const Recover = styled.div`
  font-weight: 500;
  font-size: 1rem;
  color: ${siteColors.link};
`;

export const LogoBox = styled.div`
   background-color: #303f9f;
   width: 328px;
   height: 90px;
   border-radius: 10px;
   display: flex;
   justify-content: center;
   align-items: center;
   @media ${device.mobileM} {
     height: 80px;
     width: 240px;
   }
 `;

 export const RegisterFormBox = styled.div`
   width: 80%;
   padding: 24px;
   flex-direction: column;
   justify-content: space-between;
   height: 100%;
   @media ${device.tablet} {
     width: 100%
   }
   @media ${device.mobileM} {
     padding: 8px;
     padding-top: 24px;
   }
 `;
 export const Box = styled.div`
   padding: 24px;
   width: 80%;
   @media ${device.mobileM} {
     width: 100%;
   }
 `;
 export const ImageBox = styled.div`
   height: 87px;
   width: 286px;
   @media ${device.mobileM} {
     height: 60px;
     width: 240px;
   }
 `;
 
export const RegisterCard = styled.div`
  width: 600px;
 `
export const DisplayBox = styled.div`
  max-width: 50%;
  @media ${device.tablet} {
    max-width: 100%
  }
`;